// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m3-0";
export var assigneeDetails = "_m3-1";
export var assigneeInfo = "_m3-2";
export var dropdownContainer = "_m3-4";
export var dropdownImage = "_m3-5";
export var editAssigneeInfo = "_m3-3";
export var editAssigneeModalContainer = "_m3-6";
export var hidden = "_m3-8";
export var input = "_m3-7";